import { useAppSelector } from '@/hooks/store';
import { useImpersonation } from '@/hooks/useImpersonation';
import { selectCurrentUser } from '@/store/features/users/current-user.slice';
import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledBanner = styled.div`
  width: 100%;
  background-color: var(--red-dark);
  color: var(--white-main);
  padding: var(--small-padding) var(--medium-padding);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: var(--small-font-size);
  font-weight: 500;

  strong {
    font-weight: 700;
  }
`;

const StyledWarningIcon = styled.i`
  font-size: var(--medium-font-size);
  margin-right: var(--xxsmall-padding);
`;

export const ImpersonationBanner: React.FC = () => {
  const { t } = useTranslation();
  const currentUser = useAppSelector(selectCurrentUser);
  const { endImpersonation, isCurrentlyImpersonating } = useImpersonation();

  const handleEndImpersonation = () => {
    endImpersonation();
  };

  // Check if we're currently impersonating
  if (!isCurrentlyImpersonating()) {
    return null;
  }

  const impersonatedUserName = currentUser?.username;

  return (
    <StyledBanner>
      <FlexContainer gap={8} align="center" justify="space-between">
        <StyledWarningIcon className="pi pi-exclamation-triangle" />
        <span
          dangerouslySetInnerHTML={{
            __html: t('impersonation.banner.message', {
              user: impersonatedUserName,
            }),
          }}
        />
        <AppButton
          className="ml-auto"
          severity="secondary"
          label={t('impersonation.banner.endSession')}
          onClick={handleEndImpersonation}
        />
      </FlexContainer>
    </StyledBanner>
  );
};
